{
  "name": "m2-wall",
  "seed": 1,
  "track": null,
  "fixedDtMs": 16.666666666666668,
  "cars": [{ "id": "player", "spawn": { "x": 200, "y": 360, "angle": 0 }, "ai": null }],
  "walls": [{ "x": 860, "y": 360, "w": 40, "h": 520, "angle": 0.5 }],
  "inputs": [{ "frame": 0, "car": 0, "throttle": 1, "steer": 0, "handbrake": false }],
  "captures": [
    { "frame": 100, "name": "contact" },
    { "frame": 170, "name": "slide" }
  ]
}
